import AppRoutes from "./routes";
import "react-day-picker/dist/style.css";

function App() {
  return <AppRoutes />;
}

export default App;
